import { Mask } from '../../interfaces/mask.interface';

const SEPERATORS = '[- ]+';
const UPPERCASE_LETTER_MASK = String.raw`\[A\-Z\]\{*(\d+)*\}*`;
const NUMBER_SEQUENCE_MASK = String.raw`\\d\{*(\d+)*\}*`;
const PREFIX_MASK = String.raw`^\^*[A-Z]+[- ]`;
const ARTIFACTS = `^${SEPERATORS}|${SEPERATORS}$`;

const COMBINED_REGEX = new RegExp(
  `${UPPERCASE_LETTER_MASK}|${NUMBER_SEQUENCE_MASK}|${SEPERATORS}`,
  'g',
);

export function createMaskFromRegexString(regexString: string): Mask {
  if (!regexString) {
    return { mask: '' };
  }

  const matches: string[] = regexString.match(COMBINED_REGEX) ?? [];

  let mask = '';
  let prefix = regexString.match(new RegExp(PREFIX_MASK, 'g'))?.at(0) ?? undefined;
  prefix = prefix?.startsWith('^') ? prefix?.replace('^', '') : prefix;

  for (let matchedString of matches) {
    matchedString = matchedString.replaceAll(
      new RegExp(NUMBER_SEQUENCE_MASK, 'g'),
      (_, countGroup) => {
        const n = Number(countGroup);
        return '0'.repeat(n || 1);
      },
    );

    matchedString = matchedString.replaceAll(
      new RegExp(UPPERCASE_LETTER_MASK, 'g'),
      (_, countGroup) => {
        const n = Number(countGroup);
        return 'S'.repeat(n || 1);
      },
    );

    mask += matchedString;
  }

  mask = mask.replaceAll(new RegExp(ARTIFACTS, 'g'), '');

  return { mask, prefix };
}
